require('../../modules/es6.object.assign');
module.exports = require('../../modules/$.core').Object.assign;


/*****************
 ** WEBPACK FOOTER
 ** /home/rengasturku/nettivanne/~/babel-runtime/~/core-js/library/fn/object/assign.js
 ** module id = 355
 ** module chunks = 0 1 3 10 11 12 13 14 15 16 17 19 20 21 22 23 24 25 27
 **/